/** Redact known credential URL shapes without relying on replace callback offsets. */
export function maskTokensInUrl(value: string): string {
  return value
    .replace(/(\/(?:upload|signoff|verify|reset-password)\/)[a-zA-Z0-9_.~-]+/gi, "$1[REDACTED]")
    .replace(/((?:[?&#]|\b)(?:access_token|refresh_token|token|token_hash|code|apikey|api_key)=)[^&#\s]*/gi, "$1[REDACTED]");
}

const PRIVATE_KEYS = new Set([
  "password", "token", "accesstoken", "refreshtoken", "tokenhash", "secret",
  "apikey", "authorization", "cookie", "setcookie", "xsupabaseauth",
  "email", "phone", "postcode", "address", "name", "fullname", "body", "payload", "message",
]);

/** Bound recursion and remove sensitive keys even inside arrays/nested context. */
export function scrubObject(
  object: Record<string, unknown> | undefined,
): Record<string, unknown> | undefined {
  if (!object) return object;
  const seen = new WeakSet<object>();
  function scrub(value: unknown, depth: number): unknown {
    if (typeof value === "string") {
      return value.length > 500 ? "[TRUNCATED]" : maskTokensInUrl(value);
    }
    if (!value || typeof value !== "object") return value;
    if (depth > 8) return "[TRUNCATED]";
    if (seen.has(value)) return "[CIRCULAR]";
    seen.add(value);
    const result = Array.isArray(value)
      ? value.map((entry) => scrub(entry, depth + 1))
      : Object.fromEntries(Object.entries(value).map(([key, entry]) => [
          key,
          PRIVATE_KEYS.has(key.toLowerCase().replace(/[-_]/g, ""))
            ? "[REDACTED]"
            : scrub(entry, depth + 1),
        ]));
    seen.delete(value);
    return result;
  }
  return scrub(object, 0) as Record<string, unknown>;
}

export function scrubHeaders(headers: Record<string, string>): Record<string, string> {
  return Object.fromEntries(Object.entries(headers).filter(([key]) =>
    !["authorization", "cookie", "set-cookie", "x-supabase-auth", "x-api-key", "apikey"]
      .includes(key.toLowerCase()),
  ));
}
